import React from 'react';
import type { Brand, BrandImage } from '../../shop-builder/types';

interface EditableBrandsProps {
  brands: (Brand | null)[];
}

type BrandWithRectImage = Brand & {
  rect_image: BrandImage;
};

function hasRectImage(brand: Brand | null): brand is BrandWithRectImage {
  return brand?.rect_image !== undefined;
}

export default function EditableBrands(props: EditableBrandsProps) {
  const brandsWithImages = props.brands.filter(hasRectImage);

  return (
    <div className='brand-list'>
      {brandsWithImages.map((brand) => (
        <picture key={brand.id}>
          <source srcSet={brand.rect_image.srcsets.avif} type='image/avif' />
          <source srcSet={brand.rect_image.srcsets.webp} type='image/webp' />
          <source srcSet={brand.rect_image.srcsets.jpeg} type='image/jpeg' />
          <img
            className='brand-list__icon'
            src={brand.rect_image.webp[120]}
            alt=''
          />
        </picture>
      ))}
    </div>
  );
}
